import { render, staticRenderFns } from "./ABTestSettings.vue?vue&type=template&id=cf0311b8&"
import script from "./ABTestSettings.vue?vue&type=script&lang=js&"
export * from "./ABTestSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf0311b8')) {
      api.createRecord('cf0311b8', component.options)
    } else {
      api.reload('cf0311b8', component.options)
    }
    module.hot.accept("./ABTestSettings.vue?vue&type=template&id=cf0311b8&", function () {
      api.rerender('cf0311b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/ABTest/ABTestSettings.vue"
export default component.exports